





















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PurchasedList from "@/services/payment/purchasedList";
import Button from "@/components/Button/Button.vue";
import LocalizeUtil from "@/services/payment/localize";

@Component({
  components: { Button }
})
export default class MultOfferItem extends Vue {
  @Prop()
  private offer: any;
  @Prop()
  private likeClass: any;
  @Prop()
  private iconName: any;
  @Prop({ default: "" })
  private text!: string;

  private isClaimed: boolean = true;
  private restNum: number = 0;

  get claimClass() {
    return this.isClaimed ? "claim" : "";
  }

  get leftImgSrc() {
    const name =
      this.likeClass === "follow"
        ? "lh_special_three_follower"
        : "lh_special_three_like";
    return require(`@/assets/icons-file/special_offer/${name}@3x.png`);
  }

  get calcWidth() {
    const localPrice = LocalizeUtil.getLocalizePriceByOffer(this.offer);
    const price_str_length = localPrice.length;
    if (price_str_length > 6) {
      const scale = 7 / price_str_length;
      return `transform: scale(${scale});transform-origin: right;`;
    } else {
      return "";
    }
  }

  // 当下一阶段显示的也是当前组件时，组件不会被注销，导致isClaimed不会发生改变，下一阶段的offer会被灰掉，所以必须要监听offer变化，实时判断是否isClaimed
  @Watch("offer", { deep: true })
  private watchOffer() {
    this.judgeWhetherClaimed();
  }

  private judgeWhetherClaimed() {
    if (PurchasedList.getPurchaseList().length === 0) {
      this.isClaimed = false;
    } else {
      const purchasedNum = PurchasedList.getPurchaseList().filter((item: any) => {
        const offerData = item.offer_data || item.receipt_data;
        return offerData && (offerData.offer_id === this.offer.offer_id);
      }).length;
      this.isClaimed = purchasedNum >= this.offer.limit_count;
      this.restNum = this.offer.limit_count - purchasedNum;
      console.log("isClaimed", this.isClaimed, purchasedNum, this.offer.limit_count);
      // this.isClaimed = PurchasedList.getPurchaseList().some((item: any) => {
      //   const offerData = item.offer_data || item.receipt_data;
      //   if (offerData) {
      //     return offerData.offer_id === this.offer.offer_id;
      //   } else {
      //     return false;
      //   }
      // });
    }
  }
  private created() {
    this.judgeWhetherClaimed();
  }
  private activated() {
    this.judgeWhetherClaimed();
  }

  private buyOffer() {
    !this.isClaimed && this.$emit("buyOffer", this.offer);
  }
}
